import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './UserAvatar.css';

interface UserAvatarSimpleProps {
  size?: number;
}

/**
 * Simple user avatar without dropdown menu
 * Used in session panel where menu is not needed
 */
export const UserAvatarSimple: React.FC<UserAvatarSimpleProps> = ({ size = 32 }) => {
  const { user } = useAuth();

  if (!user) return null;

  // Get user initials (first two letters or first letter of each word)
  const getInitials = (name: string): string => {
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  // Generate consistent color from user ID
  const getColorFromId = (id: string): string => {
    const colors = [
      '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3',
      '#00bcd4', '#009688', '#4caf50', '#ff9800', '#ff5722'
    ];
    // Convert string id to number for color selection
    const numId = parseInt(id, 10) || 0;
    return colors[numId % colors.length];
  };

  const avatarStyle = {
    backgroundColor: getColorFromId(user.id),
    width: size,
    height: size,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: size * 0.4,
    fontWeight: 600,
    color: '#ffffff',
    userSelect: 'none' as const,
  };

  return (
    <div style={avatarStyle} title={user.name}>
      {user.imageUrl ? (
        <img 
          src={user.imageUrl} 
          alt={user.name} 
          style={{ 
            width: '100%', 
            height: '100%', 
            borderRadius: '50%',
            objectFit: 'cover'
          }} 
        />
      ) : (
        getInitials(user.name)
      )}
    </div>
  );
};
